<template lang="pug">
#flowBody(v-loading="loading" element-loading-text="流程数据读取中...")
  //- 流程分类
  .flowGroup(v-for="item in flowList" :key="item.id")
    .groupDtoName {{item.flowGroupDto.name}}
    .groupDtoList
      .dtoItem(v-for="definition in item.flowDefinitionDtoList" :key="definition.id" :title="definition.name" @click="flowItemClick(definition)")
        img(:src="showIcon(definition.iconPrefix)")
        span {{definition.name}}
</template>

<script>
import flowService from "@/CommonDP/service/flow-service";
import { mapState } from "vuex";
import { openFlow } from "@/CommonDP/components/processComponents/flowNew/index.js";
const approvalProps = () => ({
  version: "",
  definitionId: "",
  flowKey: ""
});
export default {
  props: {
    // 是否是项目内审批
    isProject: {
      type: Boolean,
      default: false
    }
  },
  data () {
    return {
      loading: false,
      flowList: [],
      approvalParams: approvalProps()
    };
  },
  computed: {
    ...mapState({
      prjInfo: (state) => state.projectMg.prjObj,
      enterpriseId: (state) => state.enterprise.enterpriseId
    })
  },
  mounted () {
    this.getflowList();
  },
  methods: {
    async getflowList() {
      this.loading = true;
      const url = flowService[this.requestUrl()];
      const res = await url(this.enterpriseId, this.prjInfo.prjCategoryId || "", this.prjInfo.prjId);
      this.flowList = res.data || [];
      this.loading = false;
    },
    requestUrl() {
      return !this.isProject ? "queryGroupInfoList" : "queryGroupPrjList";
    },
    // 发起流程
    async flowItemClick(row) {
      const success = await this.checkCanStart(row);
      if (!success) {
        return;
      }
      const { currentVersionId, flowKey, startMode } = row;
      const data = { currentVersionId, flowKey, approveType: "add", enterpriseId: this.enterpriseId, isProject: this.isProject };
      if (startMode === 'stdNew') {
        const query = { approveType: 'add', ...data };
        const routeUrl = this.$router.resolve({ path: "/examine-new", query });
        window.open(routeUrl.href, "_blank");
      } else {
        await openFlow(data);
      }
    },
    async checkCanStart(row) {
      const json = {
        flowKey: row.flowKey,
        flowDefinitionId: row.flowDefinitionId,
        enterpriseId: this.enterpriseId,
        prjId: this.prjInfo?.prjId
      };
      await flowService.checkCanStart(json);
      return true;
    },
    showIcon(iconPrefix) {
      return require(`@/CommonDP/assets/xunhun/${Number(iconPrefix) || 0}.png`);
    }
  }
};
</script>

<style lang="scss" scoped>
#flowBody {
  width: 100%;
  height: 100%;
  padding: 0 10px;
  overflow: hidden;
  overflow-y: auto;

  .flowGroup {
    width: 100%;
    padding: var(--middle-space) 0;
  }
}

.groupDtoName {
  width: 100%;
  height: 14px;
  line-height: 14px;
  font-size: 14px;
  font-weight: 600;
  border-left: 3px solid var(--theme-color);
  padding-left: 8px;
}

.groupDtoList {
  width: 100%;
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;
}

.dtoItem {
  background: #fff;
  box-shadow: 0 0 10px rgba(85, 132, 255, .04);
  border-radius: 10px;
  margin-top: var(--middle-space);
  margin-right: var(--middle-space);
  padding-right: 5px;
  width: 168px;
  min-width: 168px;
  height: 60px;
  display: flex;
  flex-direction: row;
  align-items: center;
  cursor: pointer;

  img {
    width: 36px;
    height: 36px;
    margin-left: 10px;
    margin-right: 10px;
  }

  span {
    font-size: 14px;
    color: var(--key-color);
    word-break: keep-all;
    overflow: hidden;
    text-overflow: ellipsis;
    text-align: center;
  }

  span:hover {
    color: var(--theme-color);
  }
}

.dtoItem:hover {
  box-shadow: 5px 5px 5px #aaaaaa;
}
</style>
